import Icon from '../components/Icon.vue'

Icon.register({
  'id-card': {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M528 32H48C21.5 32 0 53.5 0 80V96H576V80C576 53.5 554.5 32 528 32zM0 432C0 458.5 21.5 480 48 480H528C554.5 480 576 458.5 576 432V128H0V432zM352 200C352 195.6 355.6 192 360 192H504C508.4 192 512 195.6 512 200V216C512 220.4 508.4 224 504 224H360C355.6 224 352 220.4 352 216V200zM352 264C352 259.6 355.6 256 360 256H504C508.4 256 512 259.6 512 264V280C512 284.4 508.4 288 504 288H360C355.6 288 352 284.4 352 280V264zM352 328C352 323.6 355.6 320 360 320H504C508.4 320 512 323.6 512 328V344C512 348.4 508.4 352 504 352H360C355.6 352 352 348.4 352 344V328zM176 192C211.3 192 240 220.7 240 256S211.3 320 176 320 112 291.3 112 256 140.7 192 176 192zM67.1 396.2C75.5 370.5 99.6 352 128 352H136.2C148.5 357.1 161.9 360 176 360S203.6 357.1 215.8 352H224C252.4 352 276.5 370.5 284.9 396.2 288.1 406.1 279.7 416 269.3 416H82.7C72.3 416 63.9 406 67.1 396.2z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/id-card.js
// module id = JRNZ
// module chunks = 144